import { render } from "./Copyright.vue?vue&type=template&id=5be382dc"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"

import "./Copyright.vue?vue&type=style&index=0&id=5be382dc&lang=scss"
script.render = render

export default script